<template>
    <div data-component="NoResults"
         class="no-results"
         :class="{
             'no-results--light': color === 'light',
         }">
        <i :class="icon"></i>
        <p v-if="text">
            {{ text }}
        </p>
        <p v-else-if="lang">
            {{ l(lang) }}
        </p>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'NoResults',

    props: {
        icon: {
            type: String,
            required: true,
        },

        lang: {
            type: String,
            default: null,
        },

        text: {
            type: String,
            default: null,
        },

        color: {
            type: String,
            default: 'dark',
        },
    },
};
</script>

<style lang="less">
@import "../../less/variables";

.no-results {
    padding: 30px;
    width: 100%;
    display: flex !important; // Override the > div display:flex on elements in the .items-panel
    align-items: center;
    justify-content: center;
    flex-direction: column;
    grid-gap: @half-gutter-width;
    color: @text-muted;

    > i {
        font-size: 26px;
    }

    > p {
        margin: 0;
        font-size: 16px;
    }

    &--light {
        color: @white;
    }
}
</style>
